import { createFileRoute } from '@tanstack/react-router'

// Route config only. The page component is code-split into `people.lazy.tsx`
// (the single source of truth for the People UI). Keep this file free of a
// `component` so the lazy component renders without an override — see the
// duplicate-file drift that previously hid RFC-199 lifecycle + Add-from-members.
export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/people'
)({
  staticData: { pageHeader: { title: 'People', pad: false } },
})
